import React from 'react';

import {
  observer,
} from 'mobx-react';

import {
  Button,
  Card,
} from 'react-bootstrap';

import {
  useHistory,
} from 'react-router-dom';

import LayoutStaffPortal from 'layout/LayoutStaffPortal';

import {
  GetStaffPortalStore,
} from 'SessionState/Staff/StaffPortalStore';

import ReadOnlyStaffDashboard from './ReadOnlyStaffDashboard';

import StaffPortalShell from './StaffPortalShell';

const StaffDashboard =
  observer(() => {
    const history =
      useHistory();

    const staffStore =
      GetStaffPortalStore();

    const currentTabulator =
      staffStore.CurrentTabulator;

    // =====================================================
    // LOGOUT
    // =====================================================

    const handleLogout =
      (): void => {
        staffStore
          .logoutTabulator();

        history.push(
          '/staff/login',
        );
      };

    // =====================================================
    // SHELL HANDLES NO SESSION
    // =====================================================

    if (!currentTabulator) {
      return (
        <StaffPortalShell
          title="Staff Portal"
          description="Hello Tiara Staff Portal"
        >
          <></>
        </StaffPortalShell>
      );
    }

    // =====================================================
    // ACCESS LEVEL
    // =====================================================

    const isAdmin =
      currentTabulator
        .accessLevel ===
      'Admin';

    // =====================================================
    // READ ONLY TABULATOR
    // =====================================================

    if (!isAdmin) {
      return (
        <StaffPortalShell
          title="Staff Portal"
          description="Hello Tiara Staff Portal"
        >
          <LayoutStaffPortal
            staffView="readonly"
          >
            <ReadOnlyStaffDashboard
              onLogout={
                handleLogout
              }
            />
          </LayoutStaffPortal>
        </StaffPortalShell>
      );
    }

    // =====================================================
    // ADMIN TABULATOR
    // =====================================================

    return (
      <StaffPortalShell
        title="Staff Portal"
        description="Hello Tiara Staff Portal"
      >
        <LayoutStaffPortal
          staffView="admin"
        >
          <div className="container py-5">
            <Card className="shadow-sm border-0">
              <Card.Body className="text-center p-5">
                <h1 className="display-4 fw-bold text-primary mb-3">
                  ADMIN TABULATOR
                </h1>

                <p className="text-muted mb-4">
                  Full tabulation access
                </p>

                <div className="mb-3">
                  <strong>
                    Pageant ID:
                  </strong>{' '}
                  {
                    currentTabulator
                      .pageantId
                  }
                </div>

                <div className="mb-3">
                  <strong>
                    Pageant Tabulation ID:
                  </strong>{' '}
                  {
                    currentTabulator
                      .pageantTabulationId
                  }
                </div>

                <div className="mb-4">
                  <strong>
                    Access Level:
                  </strong>{' '}

                  <span className="text-success fw-bold">
                    {
                      currentTabulator
                        .accessLevel
                    }
                  </span>
                </div>

                <Button
                  variant="outline-danger"
                  onClick={
                    handleLogout
                  }
                >
                  Logout
                </Button>
              </Card.Body>
            </Card>
          </div>
        </LayoutStaffPortal>
      </StaffPortalShell>
    );
  });

export default StaffDashboard;